import React from "react";
import style from "./event-card.module.css";
import Participants from "../participants/participants";
import { useNavigate } from "react-router-dom";
import { TEvent } from "../../types";
import AppHelper from "../../utils/helper";
import { decodeHtmlEntities, toSafeHtml } from "../../utils/html";
import LocationIcon from "../icons/location-icon";
import MetroIcon from "../icons/metro-icon";
import TimeIcon from "../icons/time-icon";
import PriceIcon from "../icons/price-icon";
import EventHead from "./event-head";

interface Props {
    event: TEvent;
}



const EventCardShort = ({ event }: Props) => {
    const navigate = useNavigate();
    const titleText = decodeHtmlEntities(event.short_title || event.title);
    const isCardClosed = Boolean(event.is_card_closed);
    const locationText = event.metro_station || event.location;
    const LocationMarkerIcon = event.metro_station ? MetroIcon : LocationIcon;

    const handleEventClick = (eventId: number) => {
        if (isCardClosed) {
            return;
        }

        navigate(`/events/${eventId}`);
    };

    const startTime = AppHelper.formatTime(event.time_start);
    const endTime = AppHelper.formatTime(event.time_end);

    let timeDisplay = "";
    if (startTime && endTime) {
        timeDisplay = `${startTime}-${endTime}`;
    } else if (startTime) {
        timeDisplay = `с ${startTime}`;
    }

    const isFinished = event.is_finished;

    return (
        <div
            className={`${style.card} ${isCardClosed ? style.cardClosed : ""}`}
            onClick={() => handleEventClick(event.id)}
        >
            <div className={style.box}>
                <EventHead event={event} />
                <div className={style.content}>
                    <h2 className={style.title}>{titleText}</h2>
                    <div className={style.infoPanel}>
                        {locationText && (
                            <div className={style.location}>
                                <LocationMarkerIcon />
                                <span>{locationText}</span>
                            </div>
                        )}
                        {timeDisplay && (
                            <div className={style.time}>
                                <TimeIcon />
                                <span>{timeDisplay}</span>
                            </div>
                        )}
                        <div className={style.price}>
                            <PriceIcon />{" "}
                            <span>{AppHelper.formatPrice(event.price)}</span>
                        </div>
                    </div>

                    <div
                        className={style.intro}
                        dangerouslySetInnerHTML={toSafeHtml(event.intro)}
                    />
                    
                    <Participants event={event} />

                    {!isFinished && event.is_registered && (
                        <div className="text-center text-[12px] text-[#6b7280]">
                            {/* Вы уже записаны */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventCardShort;
